import { authenticate, apiPost } from "@redriver/cinnamon";

const NAMESPACE = "SYSTEM/AUTHENTICATOR_CHECK";

const ActionTypes = {
  RequestAuthentication: `${NAMESPACE}/REQUEST_AUTHENTICATION`,
  UseRecoveryCode: `${NAMESPACE}/USE_RECOVERY_CODE`,
};

export const requestAuthentication = (
  { totp },
  token,
  { applyAuth = true } = {}
) => async (dispatch) => {
  const authAction = apiPost(
    ActionTypes.RequestAuthentication,
    "auth/mfa/totp/auth",
    { token, totp },
    { auth: false, preventErrorNotification: true }
  );

  const result = await dispatch(authAction);

  const { success, response } = result;
  // callers that show something before the user should actually be logged in
  // (e.g. the setup flow's "save your recovery codes" step) pass applyAuth:
  // false so they can hold the tokens and apply them only once that's done
  if (success && applyAuth) {
    const { access, refresh } = response.tokens;
    dispatch(authenticate(access, refresh));
  }

  return result;
};

export const useRecoveryCode = ({ code }, token) =>
  apiPost(
    ActionTypes.UseRecoveryCode,
    "auth/mfa/recovery/code",
    { token, code },
    { auth: false, preventErrorNotification: true }
  );
